import { render, staticRenderFns } from "./UpdatePatientFamilyHistoryForm.vue?vue&type=template&id=5316a2ee&"
import script from "./UpdatePatientFamilyHistoryForm.vue?vue&type=script&lang=js&"
export * from "./UpdatePatientFamilyHistoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports